import { GetContractResponse, TerminationCreationResourceReason, TerminationCreatorReadResourceType } from '@/api/generated/engageUIApiEndpoints.schemas'
import { FlyoutMessage, FlyoutMessages, FlyoutMessageType, TerminatedByType, TerminationReasonType } from '@/domain/contract/types/messages'

export const mapToMessages = (resource: GetContractResponse): FlyoutMessages => {
  const messages: FlyoutMessage[] = []

  if (resource.termination) {
    if (new Date(resource.termination.terminateAt) < new Date()) {
      messages.push({
        type: FlyoutMessageType.Terminated,
        reason: determineTerminationReason(resource.termination.creation.reason),
        terminationDate: new Date(resource.termination.terminateAt),
        terminatedBy: resource.termination.creation.createdBy.displayName,
        terminatedByType: determineTerminationByType(resource.termination.creation.createdBy.type)
      })
    } else {
      messages.push({
        type: FlyoutMessageType.InTermination,
        reason: determineTerminationReason(resource.termination.creation.reason),
        terminationDate: new Date(resource.termination.terminateAt),
        terminatedBy: resource.termination.creation.createdBy.displayName,
        terminatedByType: determineTerminationByType(resource.termination.creation.createdBy.type)
      })
    }
  }
  return { messages }
}

const determineTerminationReason = (reason: TerminationCreationResourceReason): TerminationReasonType => {
  switch (reason) {
    case TerminationCreationResourceReason.INITIAL_MIGRATION:
      return TerminationReasonType.INITIAL_MIGRATION
    case TerminationCreationResourceReason.BAD_PAYMENT:
      return TerminationReasonType.BAD_PAYMENT
    case TerminationCreationResourceReason.PRICING:
      return TerminationReasonType.PRICING
    case TerminationCreationResourceReason.QUALITY_OF_SERVICE:
      return TerminationReasonType.QUALITY_OF_SERVICE
    case TerminationCreationResourceReason.NOT_NEEDED_ANYMORE:
      return TerminationReasonType.NOT_NEEDED_ANYMORE
    case TerminationCreationResourceReason.REVOCATION_OF_CONSENT:
      return TerminationReasonType.REVOCATION_OF_CONSENT
    case TerminationCreationResourceReason.OBJECTION_TO_TARIFF_CHANGE:
      return TerminationReasonType.OBJECTION_TO_TARIFF_CHANGE
    case TerminationCreationResourceReason.EXTRAORDINARY:
      return TerminationReasonType.EXTRAORDINARY
    case TerminationCreationResourceReason.EXTRAORDINARY_SUBSTITUTE:
      return TerminationReasonType.EXTRAORDINARY_SUBSTITUTE
    case TerminationCreationResourceReason.OTHER:
      return TerminationReasonType.OTHER
    case TerminationCreationResourceReason.ORDINARY:
      return TerminationReasonType.ORDINARY
    case TerminationCreationResourceReason.CONTRACT_REVOCATION:
      return TerminationReasonType.CONTRACT_REVOCATION
    case TerminationCreationResourceReason.CONTRACT_REVOCATION_SUBSTITUTE:
      return TerminationReasonType.CONTRACT_REVOCATION_SUBSTITUTE
  }
}

const determineTerminationByType = (type: TerminationCreatorReadResourceType): TerminatedByType => {
  switch (type) {
    case TerminationCreatorReadResourceType.CUSTOMER:
      return TerminatedByType.CUSTOMER
    case TerminationCreatorReadResourceType.ENBW:
      return TerminatedByType.ENBW
  }
}
